(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sindhi-cart-enhancements"] && !Shopify.designMode) return;
  try {
    
/* Cart-page gift message handler — mirrors sindhi-cart-drawer.js _bindGiftMessage
   but operates outside the custom element context. */
(function() {
  function initCartPageGift(root) {
    var gift    = root.querySelector('[data-sc-cart-page-gift]');
    if (!gift) return;
    var toggle   = gift.querySelector('[data-sc-gift-toggle]');
    var panel    = gift.querySelector('[data-sc-gift-panel]');
    var textarea = gift.querySelector('[data-sc-gift-textarea]');
    var saveBtn  = gift.querySelector('[data-sc-gift-save]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function() {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      panel.classList.toggle('is-open', !open);
      if (!open && textarea) { setTimeout(function() { textarea.focus(); }, 60); }
    });

    if (saveBtn && textarea) {
      saveBtn.dataset.scOrigLabel = saveBtn.textContent.trim();
      saveBtn.addEventListener('click', function() {
        var note = textarea.value.trim();
        saveBtn.disabled = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note })
        })
        .then(function() {
          saveBtn.classList.add('is-saved');
          saveBtn.textContent = '✓ Saved';
          setTimeout(function() {
            saveBtn.classList.remove('is-saved');
            saveBtn.textContent = saveBtn.dataset.scOrigLabel || 'Save';
            saveBtn.disabled = false;
          }, 1800);
        })
        .catch(function() { saveBtn.disabled = false; });
      });

      textarea.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); saveBtn.click(); }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initCartPageGift(document); });
  } else {
    initCartPageGift(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sindhi-whats-inside"] && !Shopify.designMode) return;
  try {
    
(function() {
  function swiUpdateOnVariant(variantId) {
    document.querySelectorAll('[data-swi-section]').forEach(function(el) {
      var sid = el.dataset.swiSection;
      var url = window.location.pathname + '?variant=' + variantId + '&section_id=' + sid;
      fetch(url).then(function(r){return r.text();}).then(function(html){
        var doc = new DOMParser().parseFromString(html,'text/html');
        var fresh = doc.querySelector('[data-swi-section="' + sid + '"]');
        if (fresh) el.replaceWith(fresh);
      }).catch(function(){});
    });
  }
  document.addEventListener('variant:update', function(e) {
    var vid = e.detail && e.detail.resource && e.detail.resource.id;
    if (vid) swiUpdateOnVariant(String(vid));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
